/**
 * Plain object Packlink's API response representation.
 *
 */

class PriceTaxMapper {
  static createModelFromResponse(response) {
    return {
      name: response.name,
      percentage: response.percentage
    };
  }
}

export { PriceTaxMapper };
//# sourceMappingURL=PriceTaxMapper.js.map
